import { Reducer } from 'redux';
import { giftCardActionTypes, giftCardStateInterface } from "./types";

export const initialState: giftCardStateInterface = {
    product: {},
}

const reducer: Reducer<giftCardStateInterface> = (state = initialState, action) => {
    switch (action.type) {
        case giftCardActionTypes.FETCH_GIFT_CARD: {
            return { ...state, product: action.payload }
        }
        default:
            return state
    }
}

export { reducer as giftCardReducer }